function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component, Children } from 'react';
import cx from 'classnames';
import convertNewlinesToCRLF from "../utils/convert-newlines-to-crlf";

var CharacterLimitIndicator =
/*#__PURE__*/
function (_Component) {
  _inherits(CharacterLimitIndicator, _Component);

  function CharacterLimitIndicator() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CharacterLimitIndicator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CharacterLimitIndicator)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasFocus: false
    });

    return _this;
  }

  _createClass(CharacterLimitIndicator, [{
    key: "_handleFocus",
    value: function _handleFocus() {
      var _this2 = this;

      return function () {
        _this2.setState({
          hasFocus: true
        });
      };
    }
  }, {
    key: "_handleBlur",
    value: function _handleBlur() {
      var _this3 = this;

      return function () {
        _this3.setState({
          hasFocus: false
        });
      };
    }
  }, {
    key: "_renderIndicator",
    value: function _renderIndicator() {
      var _this$props = this.props,
          limit = _this$props.limit,
          value = _this$props.value,
          message = _this$props.message,
          formatMessage = _this$props.formatMessage,
          formatNumber = _this$props.formatNumber;
      var hasFocus = this.state.hasFocus;
      var numChars = convertNewlinesToCRLF(value ? value.trim() : '').length;
      var charsRemaining = limit - numChars;
      if (hasFocus || charsRemaining < 0) return React.createElement("div", {
        className: cx('CharacterLimitIndicator-indicator', {
          'CharacterLimitIndicator-indicator-error': charsRemaining < 0
        })
      }, React.createElement("div", {
        className: "CharacterLimitIndicator-message"
      }, formatMessage(message, {
        limit: limit
      })), React.createElement("div", {
        className: "CharacterLimitIndicator-remaining"
      }, " (".concat(formatNumber(charsRemaining), ")")));
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var child = Children.only(children);
      return React.createElement("div", {
        className: "CharacterLimitIndicator",
        onFocus: this._handleFocus(),
        onBlur: this._handleBlur()
      }, this._renderIndicator(), child);
    }
  }]);

  return CharacterLimitIndicator;
}(Component);

_defineProperty(CharacterLimitIndicator, "defaultProps", {
  formatMessage: function formatMessage(message, _ref) {
    var limit = _ref.limit;
    return "".concat(message, " ").concat(limit);
  },
  formatNumber: function formatNumber(number) {
    return number;
  }
});

_defineProperty(CharacterLimitIndicator, "propTypes", {
  children: PropTypes.node.isRequired,
  formatNumber: PropTypes.func,
  formatMessage: PropTypes.func,
  limit: PropTypes.number.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    defaultMessage: PropTypes.string.isRequired,
    description: PropTypes.string,
    id: PropTypes.string.isRequired
  })]),
  value: PropTypes.string
});

_defineProperty(CharacterLimitIndicator, "displayName", 'CharacterLimitIndicator');

export default CharacterLimitIndicator;